import { isEmpty, round } from "lodash";
import { singleValue, isBulkFootage } from "../../../utils";

const pogDataUpdater = (updatedDetails, pog = {}, details = {}) => {
  // setting selected value present then:
  // 1. 'Y' - do calculations carry forward/update adj LF from pog and pog Notes
  // 2. 'N' - reset calculated values and adj LF except Notes
  // 3. 'E' - reset calculated values and carry forward/update adj LF and Notes
  if (!!details.selected) {
    // Settings selected 'Y'
    if ([singleValue.yes].includes(details?.selected)) {
      let updatedPog = {
        pogNumber: pog?.PlanogramNumber,
        qtyMultiplier: !!details?.qtyMultiplier
          ? details?.qtyMultiplier
          : !pog?.CustomQtyMultiplier
          ? pog?.QtyMultiplier || 1
          : null,
        discMultiplier: !!details?.discountMultiplier
          ? details?.discountMultiplier
          : !pog?.CustomDiscMultiplier
          ? pog?.DiscMultiplier || 1
          : null,
        coreDiscount: !isEmpty(details?.coreDiscount)
          ? round(details?.coreDiscount, 2)
          : !pog?.CustomCoreDiscount
          ? pog?.CoreDiscount || 0
          : null,
        nonCoreDiscount: !isEmpty(details?.nonCoreDiscount)
          ? round(details?.nonCoreDiscount, 2)
          : !pog?.CustomNonCoreDiscount
          ? pog?.NonCoreDiscount || 0
          : null,
        datingDays: !isEmpty(String(details?.datingDays))
          ? details?.datingDays || 0
          : !pog?.CustomDatingDays
          ? pog?.DatingDays || 0
          : null,
        selected: !isEmpty(details.selected) ? details.selected : pog.Selected, // Mandatory
        prevSelected: pog?.prevSelected,
        adjLineal: isBulkFootage(pog?.AdjLineal) ? null : pog?.AdjLineal, // Mandatory
        plannerNotesId: pog?.PlannerNotes || null,
        retailerNotesId: pog?.RetailerNotes || null,
      };
      updatedDetails = {
        ...updatedDetails,
        pogList: [...updatedDetails.pogList, updatedPog],
      };
      return updatedDetails;
    }

    // Settings selected 'N'
    if ([singleValue.no].includes(details?.selected)) {
      let updatedPog = {
        pogNumber: pog?.PlanogramNumber,
        qtyMultiplier: 1,
        discMultiplier: 1,
        coreDiscount: 0,
        nonCoreDiscount: 0,
        datingDays: 0,
        selected: details?.selected, // Mandatory
        prevSelected: pog?.prevSelected,
        adjLineal: isBulkFootage(pog?.LinealFootage)
          ? null
          : pog?.LinealFootage, // Mandatory
        plannerNotesId: pog?.PlannerNotes || null,
        retailerNotesId: pog?.RetailerNotes || null,
      };
      updatedDetails = {
        ...updatedDetails,
        pogList: [...updatedDetails.pogList, updatedPog],
      };
      return updatedDetails;
    }

    // Settings selected 'E'
    if ([singleValue.existing].includes(details?.selected)) {
      let updatedPog = {
        pogNumber: pog?.PlanogramNumber,
        qtyMultiplier: 1,
        discMultiplier: 1,
        coreDiscount: 0,
        nonCoreDiscount: 0,
        datingDays: 0,
        selected: details?.selected, // Mandatory
        prevSelected: pog?.prevSelected,
        adjLineal: isBulkFootage(pog?.AdjLineal) ? null : pog?.AdjLineal, // Mandatory
        plannerNotesId: pog?.PlannerNotes || null,
        retailerNotesId: pog?.RetailerNotes || null,
      };
      updatedDetails = {
        ...updatedDetails,
        pogList: [...updatedDetails.pogList, updatedPog],
      };
      return updatedDetails;
    }
  } else {
    // Perform updates based on pog selected AND settings values(except settings 'selected') value as:
    // 1. pog 'Y' - do calculations carry forward/update adj LF and Notes
    // 2. pog 'N' - reset calculated values and adj LF except Notes (skip settings values)
    // 3. pog 'E' - reset calculated values and carry forward/update adj LF and Notes (skip settings values)

    // Settings selected 'Y'
    if ([singleValue.yes].includes(pog?.Selected)) {
      let updatedPog = {
        pogNumber: pog?.PlanogramNumber,
        qtyMultiplier: !!details?.qtyMultiplier
          ? details?.qtyMultiplier
          : !pog?.CustomQtyMultiplier
          ? pog?.QtyMultiplier || 1
          : null,
        discMultiplier: !!details?.discountMultiplier
          ? details?.discountMultiplier
          : !pog?.CustomDiscMultiplier
          ? pog?.DiscMultiplier || 1
          : null,
        coreDiscount: !isEmpty(details?.coreDiscount)
          ? round(details?.coreDiscount, 2)
          : !pog?.CustomCoreDiscount
          ? pog?.CoreDiscount || 0
          : null,
        nonCoreDiscount: !isEmpty(details?.nonCoreDiscount)
          ? round(details?.nonCoreDiscount, 2)
          : !pog?.CustomNonCoreDiscount
          ? pog?.NonCoreDiscount || 0
          : null,
        datingDays: !isEmpty(String(details?.datingDays))
          ? details?.datingDays || 0
          : !pog?.CustomDatingDays
          ? pog?.DatingDays || 0
          : null,
        selected: !isEmpty(details.selected) ? details.selected : pog.Selected, // Mandatory
        prevSelected: pog?.prevSelected,
        adjLineal: isBulkFootage(pog?.AdjLineal) ? null : pog?.AdjLineal, // Mandatory
        plannerNotesId: pog?.PlannerNotes || null,
        retailerNotesId: pog?.RetailerNotes || null,
      };
      updatedDetails = {
        ...updatedDetails,
        pogList: [...updatedDetails.pogList, updatedPog],
      };
      return updatedDetails;
    }

    // Settings selected 'N'
    if ([singleValue.no].includes(pog?.Selected)) {
      let updatedPog = {
        pogNumber: pog?.PlanogramNumber,
        qtyMultiplier: 1,
        discMultiplier: 1,
        coreDiscount: 0,
        nonCoreDiscount: 0,
        datingDays: 0,
        selected: pog.Selected, // Mandatory
        prevSelected: pog?.prevSelected,
        adjLineal: isBulkFootage(pog?.LinealFootage)
          ? null
          : pog?.LinealFootage, // Mandatory
        plannerNotesId: pog?.PlannerNotes || null,
        retailerNotesId: pog?.RetailerNotes || null,
      };
      updatedDetails = {
        ...updatedDetails,
        pogList: [...updatedDetails.pogList, updatedPog],
      };
      return updatedDetails;
    }

    // Settings selected 'E'
    if ([singleValue.existing].includes(pog?.Selected)) {
      let updatedPog = {
        pogNumber: pog?.PlanogramNumber,
        qtyMultiplier: 1,
        discMultiplier: 1,
        coreDiscount: 0,
        nonCoreDiscount: 0,
        datingDays: 0,
        selected: pog.Selected, // Mandatory
        prevSelected: pog?.prevSelected,
        adjLineal: isBulkFootage(pog?.AdjLineal) ? null : pog?.AdjLineal, // Mandatory
        plannerNotesId: pog?.PlannerNotes || null,
        retailerNotesId: pog?.RetailerNotes || null,
      };
      updatedDetails = {
        ...updatedDetails,
        pogList: [...updatedDetails.pogList, updatedPog],
      };
      return updatedDetails;
    }
  }
  return updatedDetails;
};

export default pogDataUpdater;
